import React from 'react';
import './ChatMessage.css';

const ChatMessage = ({ message }) => {
  const { type, content, timestamp, tab } = message;
  
  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString();
  };

  const getMessageIcon = (type) => {
    switch (type) {
      case 'user_speech_chunk':
      case 'user_speech':
        return '👤';
      case 'ai_speech_chunk':
      case 'ai_speech':
        return '🤖';
      case 'ai_intent':
        return '🎯';
      case 'ai_interrupted':
        return '⏸️';
      default:
        return '💬';
    }
  };

  const getMessageTitle = (type) => {
    switch (type) {
      case 'user_speech_chunk':
      case 'user_speech':
        return 'User Speech';
      case 'ai_speech_chunk':
      case 'ai_speech':
        return 'AI Speech';
      case 'ai_intent':
        return 'AI Intent';
      case 'ai_interrupted':
        return 'AI Interrupted';
      default:
        return 'Message';
    }
  };

  const getMessageStyle = (type) => {
    switch (type) {
      case 'user_speech_chunk':
      case 'user_speech':
        return 'user-message';
      case 'ai_speech_chunk':
      case 'ai_speech':
        return 'ai-message';
      case 'ai_intent':
        return 'intent-message';
      case 'ai_interrupted':
        return 'system-message';
      default:
        return 'default-message';
    }
  };

  const renderIntentContent = (intentData) => {
    // Function to recursively render all key-value pairs
    const renderKeyValuePairs = (obj, indent = 0, parentKey = '') => {
      if (obj === null || obj === undefined) {
        return <div key={`${parentKey}-null`} style={{ marginLeft: `${indent * 20}px` }}><strong>null/undefined</strong></div>;
      }
      
      if (typeof obj === 'object' && !Array.isArray(obj)) {
        return Object.entries(obj).map(([key, value]) => {
          const uniqueKey = `${parentKey}-${key}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
          return (
            <div key={uniqueKey} style={{ marginLeft: `${indent * 20}px` }}>
              <strong>{key}:</strong> {renderValue(value, indent + 1, uniqueKey)}
            </div>
          );
        });
      }
      
      return renderValue(obj, indent);
    };
    
    const renderValue = (value, indent, parentKey = '') => {
      if (value === null) return <span key={`${parentKey}-null`}>null</span>;
      if (value === undefined) return <span key={`${parentKey}-undefined`}>undefined</span>;
      if (typeof value === 'object') {
        return (
          <div key={`${parentKey}-obj`}>
            {renderKeyValuePairs(value, indent, parentKey)}
          </div>
        );
      }
      return <span key={`${parentKey}-val`}>{String(value)}</span>;
    };

    return (
      <div className="intent-content">
        <div className="intent-header">
          <strong>AI Intent Data:</strong>
        </div>
        <div className="intent-details">
          {renderKeyValuePairs(intentData)}
        </div>
      </div>
    );
  };

  const renderContent = () => {
    if (type === 'ai_intent') {
      return renderIntentContent(content);
    }
    
    if (typeof content === 'string') {
      return <div className="message-text">{content}</div>;
    }
    
    if (typeof content === 'object') {
      return (
        <div className="message-text">
          <pre>{JSON.stringify(content, null, 2)}</pre>
        </div>
      );
    }
    
    return <div className="message-text">Unknown content format</div>;
  };

  return (
    <div className={`message ${getMessageStyle(type)}`}>
      <div className="message-header">
        <span className="message-icon">{getMessageIcon(type)}</span>
        <span className="message-title">{getMessageTitle(type)}</span>
        <span className="message-time">{formatTime(timestamp)}</span>
        <span className="message-tab">[{tab}]</span>
      </div>
      <div className="message-content">
        {renderContent()}
      </div>
    </div>
  );
};

export default ChatMessage; 